import React from 'react';
import classNames from 'classnames';
import * as cssUtils from 'app/utils/cssUtils';
import colorUtils from 'color';
import { noop, get } from 'lodash';
import useSheet from 'app/jss';
import IconButton from 'app/components/commons/IconButton';

type Props = {
  classes: object,
  title: string,
  children: any,
  onConfirm?: () => void,
  onCancel?: () => void,
  transparentConfirm: boolean,
};

type State = {};

class ConfirmDialog extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    onCancel: noop,
    onConfirm: noop,
  };

  render() {
    const {
      classes,
      children,
      onCancel,
      onConfirm,
      title,
    } = this.props;

    return (
      <div className={classes.confirming}>
        <div className={classes.title}>
          {title}
        </div>
        <p className={classes.text}>
          {children}
        </p>
        <div className={classes.buttonContainer}>
          <IconButton
            className={classes.confirm}
            type="icon-tick-circle"
            onClick={onConfirm}
          />
          <IconButton
            className={classes.cancel}
            type="icon-cross-circle"
            onClick={onCancel}
          />
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  const confirmColor = theme.color.primary;
  const cancelColor = theme.color.basis4;

  return {
    title: {
      fontSize: 24,
      fontWeight: 600,
      color: theme.color.basis6,
      textTransform: 'uppercase',
    },
    text: {
      fontSize: 18,
      fontWeight: 600,
      color: cancelColor,
      width: '66%',
    },
    confirming: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      flexGrow: 1,
    },
    buttonContainer: {
      display: 'flex',
      fontSize: 50,
    },
    cancel: {
      color: cancelColor,
      transition: 'color 0.2s',
      ...cssUtils.hover({
        color: colorUtils(cancelColor).darken(0.1).hex(),
      }),
    },
    confirm: {
      color: confirmColor,
      marginRight: 50,
      transition: 'color 0.2s',
      ...cssUtils.hover({
        color: colorUtils(confirmColor).darken(0.1).hex(),
      }),
    },
  };
}

export default useSheet(applyStyles)(ConfirmDialog);
